import { render, staticRenderFns } from "./ComponentAllBooks.vue?vue&type=template&id=9d1cbae2&scoped=true"
import script from "./ComponentAllBooks.vue?vue&type=script&lang=js"
export * from "./ComponentAllBooks.vue?vue&type=script&lang=js"
import style0 from "./ComponentAllBooks.vue?vue&type=style&index=0&id=9d1cbae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1cbae2",
  null
  
)

export default component.exports